"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4175],{

/***/ 50945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31567);
/* harmony import */ var _store_selectors_settings__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18851);





var HeaderTitle = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function(props) {
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$)().t;
    var chunks = [];
    var title = typeof props.children == "object" ? props.children.join("") : props.children;
    var env = _store_selectors_settings__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getEnv */ .Z.getEnv();
    if (env == "dev") {
        chunks.push("[DEV]");
    }
    if (env == "stg") {
        chunks.push("[STG]");
    }
    chunks.push(title);
    chunks.push(t("meta_title_suffix"));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
            children: chunks.join(" | ")
        })
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (HeaderTitle);


/***/ }),

/***/ 45307:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AcceptanceTermsCheckbox; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControlLabel/FormControlLabel.js + 1 modules
var FormControlLabel = __webpack_require__(50480);
// EXTERNAL MODULE: ./node_modules/@mui/material/Checkbox/Checkbox.js + 4 modules
var Checkbox = __webpack_require__(69368);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(80822);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 2 modules
var Link = __webpack_require__(23795);
// EXTERNAL MODULE: ./node_modules/@mui/material/Alert/Alert.js + 5 modules
var Alert = __webpack_require__(46901);
// EXTERNAL MODULE: ./node_modules/@mui/material/Dialog/Dialog.js
var Dialog = __webpack_require__(64666);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogTitle/DialogTitle.js
var DialogTitle = __webpack_require__(37645);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogContent/DialogContent.js + 1 modules
var DialogContent = __webpack_require__(6514);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogActions/DialogActions.js + 1 modules
var DialogActions = __webpack_require__(31425);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(7734);
// EXTERNAL MODULE: ./node_modules/react-markdown/lib/react-markdown.js
var react_markdown = __webpack_require__(30724);
var react_markdown_default = /*#__PURE__*/__webpack_require__.n(react_markdown);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
// EXTERNAL MODULE: ./src/components/ui/loading-indicator.tsx
var loading_indicator = __webpack_require__(13039);
// EXTERNAL MODULE: ./src/services/laravel_api/index.ts
var laravel_api = __webpack_require__(29513);
;// CONCATENATED MODULE: ./src/services/laravel_api/termsOfService.ts

var extendedApiSlice = laravel_api/* laravel_api.injectEndpoints */.x.injectEndpoints({
    endpoints: function(builder) {
        return {
            getTermsOfService: builder.query({
                query: function(params) {
                    return {
                        url: "/api/v2/terms-of-service",
                        params: params,
                        method: "GET"
                    };
                }
            })
        };
    }
});
var useGetTermsOfServiceQuery = extendedApiSlice.useGetTermsOfServiceQuery;

;// CONCATENATED MODULE: ./src/components/authentication/acceptance-terms-checkbox.tsx









function AcceptanceTermsCheckbox(param) {
    var value = param.value, onChange = param.onChange, onAcceptedTerms = param.onAcceptedTerms;
    var ref;
    var ref1 = (0,react.useState)(value !== null && value !== void 0 ? value : false), hasAcceptedTerms = ref1[0], setHasAcceptedTerms = ref1[1];
    var ref2 = (0,react.useState)(false), isCallbackLoading = ref2[0], setIsCallbackLoading = ref2[1];
    var ref3 = (0,react.useState)(false), termsModalOpen = ref3[0], setTermsModalOpen = ref3[1];
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var termsOfService = useGetTermsOfServiceQuery(undefined);
    var isDisabled = (0,react.useMemo)(function() {
        if (termsOfService.error) {
            return true;
        }
        return isCallbackLoading || termsOfService.isLoading;
    }, [
        isCallbackLoading,
        termsOfService.isLoading,
        termsOfService.error
    ]);
    function handleOnChange(event) {
        return _handleOnChange.apply(this, arguments);
    }
    function _handleOnChange() {
        _handleOnChange = (0,_async_to_generator/* default */.Z)(function(event) {
            var ref, value, termsVersion;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        value = event.target.checked;
                        termsVersion = (ref = termsOfService.data) === null || ref === void 0 ? void 0 : ref.version_tag;
                        if (!termsVersion) {
                            throw new Error("Terms of Service version is not available");
                        }
                        if (!(onAcceptedTerms && value)) return [
                            3,
                            2
                        ];
                        setIsCallbackLoading(true);
                        return [
                            4,
                            onAcceptedTerms(termsVersion).finally(function() {
                                return setIsCallbackLoading(false);
                            })
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        setHasAcceptedTerms(value);
                        if (onChange) {
                            onChange(value, termsVersion);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return _handleOnChange.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                    disabled: isDisabled,
                    sx: {
                        "&.Mui-disabled": {
                            color: function(theme) {
                                return theme.palette.custom.text.lightGrey;
                            }
                        }
                    },
                    checked: hasAcceptedTerms,
                    onChange: handleOnChange,
                    name: "termsAccepted",
                    color: "primary"
                }),
                label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: {
                        display: "flex",
                        alignItems: "center",
                        gap: 1
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            variant: "body2",
                            children: [
                                "I have read and agree to the",
                                " ",
                                t("terms_and_services_name"),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    component: "button",
                                    type: "button",
                                    variant: "body2",
                                    disabled: isCallbackLoading,
                                    onClick: function(e) {
                                        e.preventDefault();
                                        setTermsModalOpen(true);
                                    },
                                    sx: {
                                        verticalAlign: "baseline"
                                    },
                                    children: "Terms of Service"
                                }),
                                "."
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_indicator/* default */.Z, {
                            isLoading: isCallbackLoading || termsOfService.isLoading,
                            size: 16
                        })
                    ]
                }),
                sx: {
                    mt: 2
                }
            }),
            termsOfService.isLoading === false && termsOfService.error && /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                sx: {
                    mb: 1
                },
                severity: "error",
                children: "Failed to load Terms of Service."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
                open: termsModalOpen,
                onClose: function() {
                    return setTermsModalOpen(false);
                },
                maxWidth: "md",
                fullWidth: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogTitle/* default */.Z, {
                        children: "Terms & Services"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogContent/* default */.Z, {
                        dividers: true,
                        children: [
                            termsOfService.isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                sx: {
                                    alignItems: "center",
                                    display: "flex",
                                    justifyContent: "center",
                                    height: 100
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_indicator/* default */.Z, {
                                    isLoading: true,
                                    size: 32
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((react_markdown_default()), {
                                children: (ref = termsOfService.data) === null || ref === void 0 ? void 0 : ref.content
                            }),
                            termsOfService.isLoading === false && termsOfService.error && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                children: "Failed to load Terms of Service."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogActions/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            onClick: function() {
                                return setTermsModalOpen(false);
                            },
                            children: "Close"
                        })
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 33149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ GuestGuard; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _hooks_use_auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89731);
/* harmony import */ var _hooks_use_settings__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92268);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80822);







var GuestGuard = function(props) {
    var children = props.children;
    var auth = (0,_hooks_use_auth__WEBPACK_IMPORTED_MODULE_3__/* .useAuth */ .a)();
    var settings = (0,_hooks_use_settings__WEBPACK_IMPORTED_MODULE_4__/* .useSettings */ .r)().settings;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), checked = ref[0], setChecked = ref[1];
    var disableGuard = router.query.disableGuard;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!router.isReady) {
            return;
        }
        // You should remove the "disableGuard" check, because it's meant to be used only in the demo.
        if (auth.isAuthenticated && disableGuard !== "true") {
            router.push("/dashboard");
        } else {
            setChecked(true);
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        router.isReady
    ]);
    if (!checked) {
        return null;
    }
    // If got here, it means that the redirect did not occur, and that tells us that the user is
    // not authenticated / authorized.
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        className: "theme-".concat(settings.theme),
        children: children
    });
};
GuestGuard.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().node)
};


/***/ }),

/***/ 11901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16628);
/* harmony import */ var _mui_material_Backdrop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84808);
/* harmony import */ var _mui_material_CircularProgress__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98456);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);





/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function(props) {
    var show = props.show, fade = props.fade;
    if (fade) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            in: show,
            style: {
                transitionDelay: show ? "175ms" : "600ms"
            },
            unmountOnExit: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Backdrop__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                sx: {
                    color: "#fff",
                    zIndex: function(theme) {
                        return theme.zIndex.drawer + 1;
                    }
                },
                open: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_CircularProgress__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    color: "inherit"
                })
            })
        });
    }
    if (!show) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Backdrop__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        sx: {
            color: "#fff",
            zIndex: function(theme) {
                return theme.zIndex.drawer + 1;
            }
        },
        open: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_CircularProgress__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            color: "inherit"
        })
    });
}));


/***/ }),

/***/ 13039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LoadingIndicator; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16628);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80822);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98456);




/**
 * Displays a loading indicator with optional box and delay.
 *
 * @param {boolean} isLoading - Determines if the loading indicator should be displayed.
 * @param {boolean} withBox - If true, wraps the indicator in a full-screen box.
 * @param {boolean} darkBackground - If true, uses a dark background for the box.
 * @param {boolean} withoutDelay - If true, shows the indicator without transition delay.
 * @param {...object} rest - Additional props passed to the CircularProgress component.
 * @returns {JSX.Element} A React component displaying a loading indicator.
 */ function LoadingIndicator(_param) {
    var isLoading = _param.isLoading, withBox = _param.withBox, darkBackground = _param.darkBackground, withoutDelay = _param.withoutDelay, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "isLoading",
        "withBox",
        "darkBackground",
        "withoutDelay"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        in: isLoading,
        style: {
            transitionDelay: isLoading && !withoutDelay ? "100ms" : "0ms"
        },
        unmountOnExit: true,
        children: withBox ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            sx: {
                position: "fixed",
                zIndex: 9999,
                width: "100%",
                height: "100vh",
                top: 0,
                left: 0,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: darkBackground ? "rgba(0,0,0, 0.2)" : "rgba(255,255,255,0.5)"
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                className: "loader"
            }, rest))
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            className: "loader"
        }, rest))
    });
}


/***/ }),

/***/ 92268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ useSettings; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _contexts_settings_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48473);


var useSettings = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_contexts_settings_context__WEBPACK_IMPORTED_MODULE_1__/* .SettingsContext */ .J6);
};


/***/ }),

/***/ 60873:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var isPrintModeEnabled = function() {
    if (false) {}
    var items = document.querySelectorAll(".noPrint");
    if (!items.length) {
        return false;
    }
    return window.getComputedStyle(items[0]).display == "none";
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    isPrintModeEnabled: isPrintModeEnabled
});


/***/ }),

/***/ 4175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ login_html; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(80822);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(65582);
// EXTERNAL MODULE: ./node_modules/@mui/material/Card/Card.js + 1 modules
var Card = __webpack_require__(66242);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Alert/Alert.js + 5 modules
var Alert = __webpack_require__(46901);
// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(67720);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 2 modules
var Link = __webpack_require__(23795);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
// EXTERNAL MODULE: ./src/components/HeaderTitle.js
var HeaderTitle = __webpack_require__(50945);
// EXTERNAL MODULE: ./src/components/authentication/guest-guard.js
var guest_guard = __webpack_require__(33149);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@mui/material/AlertTitle/AlertTitle.js + 1 modules
var AlertTitle = __webpack_require__(92401);
// EXTERNAL MODULE: ./node_modules/@mui/material/TextField/TextField.js + 1 modules
var TextField = __webpack_require__(50135);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormHelperText/FormHelperText.js + 1 modules
var FormHelperText = __webpack_require__(56815);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(7734);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 120 modules
var formik_esm = __webpack_require__(85200);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 26 modules
var es = __webpack_require__(7258);
// EXTERNAL MODULE: ./src/components/saving-bar.js
var saving_bar = __webpack_require__(11901);
// EXTERNAL MODULE: ./src/hooks/use-auth.js
var use_auth = __webpack_require__(89731);
// EXTERNAL MODULE: ./src/hooks/use-mounted.js
var use_mounted = __webpack_require__(46723);
// EXTERNAL MODULE: ./src/lib/gtm.js
var gtm = __webpack_require__(38682);
// EXTERNAL MODULE: ./src/components/authentication/acceptance-terms-checkbox.tsx + 1 modules
var acceptance_terms_checkbox = __webpack_require__(45307);
;// CONCATENATED MODULE: ./src/components/authentication/jwt-login.js















var JWTLogin = function(props) {
    var isMounted = (0,use_mounted/* useMounted */.s)();
    var router = (0,next_router.useRouter)();
    var authContext = (0,use_auth/* useAuth */.a)();
    var login = (0,use_auth/* useAuth */.a)().login;
    var formik = (0,formik_esm/* useFormik */.TA)({
        initialValues: {
            email: "",
            password: "",
            termsAccepted: false,
            termsVersion: null,
            // email: "demo@devias.io",
            // password: "5e86809283e28b96d2d38537",
            submit: null,
            accountAccessErrors: []
        },
        initialErrors: {
            formError: null,
            can_login: null,
            accountAccessErrors: []
        },
        validationSchema: es.object({
            email: es.string().email("Must be a valid email").max(255).required("Email is required"),
            password: es.string().max(255).required("Password is required"),
            termsAccepted: es.boolean().oneOf([
                true
            ], "You must accept the Terms & Services")
        }),
        onSubmit: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(values, helpers) {
                var ref, errorMessage, user, can_login, accountAccessErrors, returnUrl, err;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                login(values.email, values.password, values.termsAccepted, values.termsVersion)
                            ];
                        case 1:
                            ref = _state.sent(), errorMessage = ref.errorMessage, user = ref.user, can_login = ref.can_login, accountAccessErrors = ref.accountAccessErrors;
                            if (can_login && isMounted() && user) {
                                gtm/* gtm.push */.w.push({
                                    event: "userinfo",
                                    event_action: "update",
                                    first_name: user.usr_first_name,
                                    last_name: user.usr_last_name,
                                    email: user.usr_email,
                                    phone_number: user.phone_number,
                                    company_name: user.usr_company_name,
                                    company_url: user.usr_company_url
                                });
                                returnUrl = router.query.returnUrl || "/dashboard";
                                router.push(returnUrl);
                            } else {
                                helpers.setStatus({
                                    success: false
                                });
                                helpers.setErrors({
                                    formError: errorMessage,
                                    can_login: can_login,
                                    accountAccessErrors: accountAccessErrors
                                });
                                helpers.setSubmitting(false);
                            }
                            return [
                                3,
                                3
                            ];
                        case 2:
                            err = _state.sent();
                            console.error(err);
                            if (isMounted()) {
                                helpers.setStatus({
                                    success: false
                                });
                                helpers.setErrors({
                                    formError: err.message
                                });
                                helpers.setSubmitting(false);
                            }
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(values, helpers) {
                return _ref.apply(this, arguments);
            };
        }()
    });
    (0,react.useEffect)(function() {
        if (authContext.isAuthenticated && authContext.user) {
            router.push("/dashboard");
        }
    }, []);
    var isVerified = router.query.hasOwnProperty("account_verified");
    var hasPasswordReset = router.query.hasOwnProperty("password_reset");
    var isApproved = router.query.hasOwnProperty("account_approved") ? router.query.account_approved : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        noValidate: true,
        onSubmit: formik.handleSubmit
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(saving_bar/* default */.Z, {
                show: formik.isSubmitting
            }),
            formik.errors.formError && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    mb: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                    severity: "error",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: formik.errors.formError
                    })
                })
            }),
            (formik.errors.accountAccessErrors || []).length == 0 && isVerified && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    mb: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                    severity: "success",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: "Your account is verified!"
                    })
                })
            }),
            hasPasswordReset && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    mb: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                    severity: "success",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: "Your account password has been reset. You can now log in, using your new password."
                    })
                })
            }),
            (formik.errors.accountAccessErrors || []).length == 0 && isApproved != "" && isApproved == "0" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: {
                        mb: 2
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Alert/* default */.Z, {
                        severity: "info",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertTitle/* default */.Z, {
                                children: "Account Approval"
                            }),
                            "Your account is being currently being review and it will be approve soon. Reviews usually take less than 24 hours."
                        ]
                    })
                })
            }),
            (formik.errors.accountAccessErrors || []).length > 0 && formik.errors.accountAccessErrors.map(function(item, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Alert/* default */.Z, {
                    severity: item.type,
                    sx: {
                        mt: 2,
                        mb: 2
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertTitle/* default */.Z, {
                            children: item.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            dangerouslySetInnerHTML: {
                                __html: item.text
                            }
                        })
                    ]
                }, "accountAccessErrors_".concat(index));
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                error: Boolean(formik.touched.email && formik.errors.email),
                fullWidth: true,
                helperText: formik.touched.email && formik.errors.email,
                label: "Email Address",
                margin: "normal",
                name: "email",
                onBlur: formik.handleBlur,
                onChange: formik.handleChange,
                type: "email",
                value: formik.values.email
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                error: Boolean(formik.touched.password && formik.errors.password),
                fullWidth: true,
                helperText: formik.touched.password && formik.errors.password,
                label: "Password",
                margin: "normal",
                name: "password",
                onBlur: formik.handleBlur,
                onChange: formik.handleChange,
                type: "password",
                value: formik.values.password
            }),
            formik.errors.submit && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    mt: 3
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                    error: true,
                    children: formik.errors.submit
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(acceptance_terms_checkbox/* default */.Z, {
                value: formik.values.termsAccepted,
                onChange: function(accepted, version) {
                    formik.setFieldValue("termsAccepted", accepted);
                    formik.setFieldValue("termsVersion", version);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    mt: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    disabled: formik.isSubmitting || !formik.values.termsAccepted,
                    fullWidth: true,
                    size: "large",
                    type: "submit",
                    variant: "contained",
                    children: "Log In"
                })
            })
        ]
    }));
};

// EXTERNAL MODULE: ./src/components/theme-logo.js
var theme_logo = __webpack_require__(81759);
// EXTERNAL MODULE: ./src/hooks/use-settings.js
var use_settings = __webpack_require__(92268);
// EXTERNAL MODULE: ./src/store/selectors/settings.js
var selectors_settings = __webpack_require__(18851);
// EXTERNAL MODULE: ./src/lib/utils.js
var utils = __webpack_require__(60873);
;// CONCATENATED MODULE: ./src/pages/authentication/login.html.js















var Login = function() {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var settings = (0,use_settings/* useSettings */.r)().settings;
    var router = (0,next_router.useRouter)();
    var platform = (0,use_auth/* useAuth */.a)().platform;
    var disableGuard = router.query.disableGuard;
    var systemSettings = selectors_settings/* default.getSettings */.Z.getSettings();
    (0,react.useEffect)(function() {
        gtm/* gtm.push */.w.push({
            event: "page_view"
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderTitle/* default */.Z, {
                children: "Login"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                component: "main",
                sx: {
                    backgroundColor: "background.default",
                    display: "flex",
                    flexDirection: "column",
                    minHeight: "100vh"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    maxWidth: "sm",
                    sx: {
                        py: {
                            xs: "60px",
                            md: "120px"
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                        elevation: 16,
                        sx: {
                            p: 4
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                sx: {
                                    alignItems: "center",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_logo/* default */.Z, {
                                                variant: settings.theme,
                                                sx: {
                                                    height: "auto",
                                                    width: "230px"
                                                }
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "h3",
                                        sx: {
                                            pt: 3
                                        },
                                        children: "Log in"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        color: "textSecondary",
                                        sx: {
                                            mt: 2
                                        },
                                        variant: "body2",
                                        children: "Sign in on the internal platform"
                                    })
                                ]
                            }),
                            !utils/* default.isPrintModeEnabled */.Z.isPrintModeEnabled() && systemSettings.general.env == "dev" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                                severity: "warning",
                                sx: {
                                    m: 2,
                                    mr: 0,
                                    ml: 0
                                },
                                children: "You are now in the Development Mode"
                            }),
                            !utils/* default.isPrintModeEnabled */.Z.isPrintModeEnabled() && systemSettings.status.maintenance && /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                                severity: "warning",
                                sx: {
                                    m: 2,
                                    mr: 0,
                                    ml: 0
                                },
                                children: "The application is in maintenance mode"
                            }),
                            !utils/* default.isPrintModeEnabled */.Z.isPrintModeEnabled() && systemSettings.general.env == "stg" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                                severity: "warning",
                                sx: {
                                    m: 2,
                                    mr: 0,
                                    ml: 0
                                },
                                children: "You are now in the Staging Mode"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                sx: {
                                    flexGrow: 1,
                                    mt: 3
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(JWTLogin, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                sx: {
                                    my: 3
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                direction: "row",
                                justifyContent: "space-between",
                                alignItems: "center",
                                spacing: 2,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: disableGuard ? "/authentication/password-recovery.html?disableGuard=".concat(disableGuard) : "/authentication/password-recovery.html",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                            color: "textSecondary",
                                            sx: {
                                                mt: 1
                                            },
                                            variant: "body2",
                                            children: "Forgot password"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: disableGuard ? "/authentication/register.html?disableGuard=".concat(disableGuard) : "/authentication/register.html",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                            color: "textSecondary",
                                            variant: "body2",
                                            children: "Create new account"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
Login.getLayout = function(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(guest_guard/* GuestGuard */.A, {
        children: page
    });
};
/* harmony default export */ var login_html = (Login);


/***/ })

}]);